import { types } from 'mobx-state-tree';

import stores from 'bootstrap/store';

import { ALL_TYPES_FILTER } from '../routes/activity/constants';


export const MachineTechniciansRouteStore = types.model({
  activeTechnicianId: types.maybeNull(types.string),
  filterValue: types.optional(types.string, ''),
  currentPage: types.optional(types.number, 1),
  http: types.optional(types.model({
    listingTechnicians: types.optional(types.number, 0),
    listingMachineTechnicianAppCommands: types.optional(types.number, 0),
  }), {}),

  machineTechnicianLogsFilter: types.optional(types.string, ALL_TYPES_FILTER.KEY)
})
.actions(self => ({
  setValue: (prop, value) => self[prop] = value,
  setInitialState: () => {
    self.activeTechnicianId = null;
    self.filterValue = '';
    self.currentPage = 1;
    self.http = {
      listingTechnicians: 0,
      listingMachineTechnicianAppCommands: 0,
    };
  },
  incrementHttp: (http) => ++self.http[http],
  decrementHttp: (http) => --self.http[http]
}))
.views(self => ({
  get activeTechnician() {
    return (
      self.activeTechnicianId &&
      stores.global.machineTechnicians.machineTechnicians.get(self.activeTechnicianId)
    );
  },
  getTechnicianKiosksCountCaption(machineTechnician) {
    const kiosks = (machineTechnician || {}).kiosks || [];
    const kiosksCount = kiosks.length;
    return `${kiosksCount} ${kiosksCount === 1 ? 'KIOSK' : 'KIOSKS' }`;
  },
  get activeTechnicianKiosksCaption() {
    return self.getTechnicianKiosksCountCaption(self.activeTechnician);
  },
}));

export const machineTechniciansRouteStore = MachineTechniciansRouteStore.create({});
